export type ServerError = {
  errorr: boolean;
  message: string;
  field?: string;
};
export enum ErrorType {
  UNEXPECTED_SERVER_ERROR = "unexpected-server-error"
}